import { useEffect, useRef } from "react";

interface SponsorCreative {
  id: number;
  image_url: string | null;
  alt_text: string;
  click_url: string;
  width: number;
  height: number;
}

interface Props {
  creative: SponsorCreative | null;
  slot_size: string;
  placeable_type: string;
  placeable_id: number;
}

export default function SponsorSlot({ creative, slot_size, placeable_type, placeable_id }: Props) {
  const logged = useRef(false);

  useEffect(() => {
    if (!creative || logged.current) return;
    logged.current = true;

    const csrf =
      document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? "";

    fetch("/sponsor_impressions", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrf,
        Accept: "application/json",
      },
      body: JSON.stringify({
        creative_id: creative.id,
        placeable_type,
        placeable_id,
        slot_size,
      }),
    }).catch(() => {});
  }, [creative, placeable_type, placeable_id, slot_size]);

  if (!creative || !creative.image_url) return null;

  return (
    <a
      href={creative.click_url}
      target="_blank"
      rel="nofollow sponsored noopener"
      className={`sponsor-slot sponsor-slot--${slot_size}`}
      style={{ display: "inline-block", lineHeight: 0 }}
    >
      <img
        src={creative.image_url}
        alt={creative.alt_text}
        width={creative.width}
        height={creative.height}
        /*
         * `width` pins the slot to its display size so the file's own
         * dimensions never drive layout: a 2× upload is downscaled to its
         * display size (crisp on a high-DPI screen) and a 1× upload is no
         * longer stretched past native — a 320×100 banner used to be blown up
         * to fill a ~360px phone column. `maxWidth` still lets the slot shrink
         * inside a container narrower than the display size.
         */
        style={{ width: creative.width, maxWidth: "100%", height: "auto" }}
      />
    </a>
  );
}
